import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Map from 'components/map';
import HousingProjectBlockHeader from 'components/housing-project-block-header';
import ContentWrapper from 'components/content-wrapper';
import Checkbox from 'components/checkbox';

const HousingProjectMapBlock = ({ title, map, description, theme }) => {
  const [showMapDetails, setShowMapDetails] = useState(false);

  return (
    <div
      className={cn('housing-project-map-block', {
        [`housing-project-map-block--${theme}`]: theme
      })}
    >
      <ContentWrapper>
        <HousingProjectBlockHeader title={title} description={description} />
        <div className="housing-project-map-block__checkbox-container">
          <Checkbox checked={showMapDetails} onChange={setShowMapDetails}>
            Vis detaljer
          </Checkbox>
        </div>
        {map && <Map {...map} theme={theme} showDetails={showMapDetails} />}
      </ContentWrapper>
    </div>
  );
};

HousingProjectMapBlock.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  map: PropTypes.exact(Map.propTypes),
  theme: PropTypes.string
};

HousingProjectMapBlock.propTypesMeta = {
  theme: 'exclude'
};

export default HousingProjectMapBlock;
